export default __webpack_public_path__ + "static/media/bridges_bl.1e2e791e.png";